// extracted by mini-css-extract-plugin
export var actionIcon = "_ui-0";